import { Route, Routes } from "react-router-dom";
import CompanyTree from "./CompanyTree";

export default function CompanyTreeRouter() {
  return (
    <Routes>
      <Route path="/" element={<CompanyTree />} />
    </Routes>
  );
}
